module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contacts"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('div', {
    staticClass: "headquarters"
  }, [_c('h5', [_vm._v("Headquarters")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-12"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "p-0"
  }, [_vm._v("email: "), _c('strong', [_vm._v("Support@" + _vm._s(_vm.siteName) + ".com")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "question-form"
  }, [_c('h5', [_vm._v("Send us Question")]), _vm._v(" "), _c('small', [_vm._v("* Indicates required field")]), _vm._v(" "), _c('p', [_vm._v("To help us respond to you with the most accurate answer or assistance, please begin by selecting a department or topic from the drop down below.")]), _vm._v(" "), (!_vm.form.topic) ? _c('b-form-select', {
    attrs: {
      "options": _vm.topicsList,
      "calss": "mb-3"
    },
    model: {
      value: (_vm.form.topic),
      callback: function($$v) {
        _vm.$set(_vm.form, "topic", $$v)
      },
      expression: "form.topic"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.topic) ? _c('form', [_c('b-button', {
    attrs: {
      "variant": "link"
    },
    nativeOn: {
      "click": function($event) {
        _vm.form.topic = ''
      }
    }
  }, [_vm._v("< Select a different Department or Topic")]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Department, Topic or Issue:",
      "label-size": 1
    }
  }, [_c('b-form-input', {
    staticClass: "topic",
    attrs: {
      "static": true,
      "type": "text"
    },
    model: {
      value: (_vm.form.topic),
      callback: function($$v) {
        _vm.$set(_vm.form, "topic", $$v)
      },
      expression: "form.topic"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    staticClass: "custom",
    attrs: {
      "label": "Name: *",
      "state": _vm.form.name.length ? 'success' : 'warning',
      "label-size": 1
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter  Name"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Email Address: *",
      "state": _vm.form.email.length ? 'success' : 'warning',
      "label-size": 1
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "placeholder": "Enter Email Address"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Type your Question or Inquiry: *",
      "state": _vm.form.question.length ? 'success' : 'warning',
      "label-size": 1
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": "",
      "rows": 5
    },
    model: {
      value: (_vm.form.question),
      callback: function($$v) {
        _vm.$set(_vm.form, "question", $$v)
      },
      expression: "form.question"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "button-primary"
  }, [_vm._v("Submit")])], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5 col-12"
  }, [_c('p', {
    staticClass: "p-0"
  }, [_vm._v("666 East Quaker Str., Suite 1")]), _vm._v(" "), _c('p', {
    staticClass: "p-0"
  }, [_vm._v("Orchard Park, NY 14127")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-0"
  }, [_vm._v("Phone: "), _c('strong', [_vm._v("1-800-922-0957 (option 2)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-0"
  }, [_vm._v("Fax: "), _c('strong', [_vm._v("716-508-8254")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2022ffa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/ContactPage.vue
// module id = 1474
// module chunks = 1